var _circle, _circle2, _line, _line2, _mask, _ellipse, _path, _line3, _line4, _line5, _line6, _line7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScaling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 12,
    r: 1.5,
    fill: "#898989",
    stroke: "#898989"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 2,
    r: 1.5,
    fill: "#898989",
    stroke: "#898989"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3.5,
    y1: 13,
    x2: 3.5,
    y2: 1,
    stroke: "#898989"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 13.5,
    y1: 13,
    x2: 13.5,
    y2: 1,
    stroke: "#898989"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-1_3576_13440",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.8484,
    cy: 1.52632,
    rx: 0.155039,
    ry: 0.526316
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.8484,
    cy: 1.52632,
    rx: 0.155039,
    ry: 0.526316,
    fill: "#898989"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0034 1.52632C13.0034 1.60371 12.993 1.63567 12.9988 1.61591C12.9998 1.61257 13.0204 1.53704 13.0881 1.43977C13.1356 1.37164 13.3766 1.05263 13.8484 1.05263V3.05263C14.363 3.05263 14.6448 2.70416 14.7293 2.58278C14.8342 2.43224 14.8882 2.27963 14.9173 2.18105C14.9792 1.9708 15.0034 1.7396 15.0034 1.52632H13.0034ZM13.8484 1.05263C14.3202 1.05263 14.5612 1.37164 14.6086 1.43977C14.6764 1.53704 14.697 1.61257 14.698 1.61591C14.7038 1.63567 14.6934 1.60371 14.6934 1.52632H12.6934C12.6934 1.7396 12.7176 1.9708 12.7795 2.18105C12.8086 2.27963 12.8626 2.43224 12.9675 2.58278C13.052 2.70416 13.3338 3.05263 13.8484 3.05263V1.05263ZM14.6934 1.52632C14.6934 1.44892 14.7038 1.41696 14.698 1.43672C14.697 1.44006 14.6764 1.5156 14.6086 1.61287C14.5612 1.68099 14.3202 2 13.8484 2V0C13.3338 0 13.052 0.348468 12.9675 0.469855C12.8626 0.620392 12.8086 0.773 12.7795 0.871585C12.7176 1.08183 12.6934 1.31303 12.6934 1.52632H14.6934ZM13.8484 2C13.3766 2 13.1356 1.68099 13.0881 1.61287C13.0204 1.5156 12.9998 1.44006 12.9988 1.43672C12.993 1.41696 13.0034 1.44892 13.0034 1.52632H15.0034C15.0034 1.31303 14.9792 1.08183 14.9173 0.871585C14.8882 0.773 14.8342 0.620392 14.7293 0.469855C14.6448 0.348468 14.363 0 13.8484 0V2Z",
    fill: "#898989",
    mask: "url(#path-5-inside-1_3576_13440)"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 2.13281,
    y1: 12.5,
    x2: 13.8661,
    y2: 12.5,
    stroke: "#898989",
    strokeDasharray: "1 1"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 1.5,
    x2: 14,
    y2: 1.5,
    stroke: "#898989",
    strokeDasharray: "1 1"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 15.5912,
    y2: -0.5,
    transform: "matrix(0.684934 -0.728605 0.643417 0.765516 3.19922 13)",
    stroke: "#898989"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 13.5,
    y1: 1.70312,
    x2: 15.7,
    y2: 1.70312,
    stroke: "#898989",
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 12.5,
    x2: 2.7,
    y2: 12.5,
    stroke: "#898989",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScaling);
export default __webpack_public_path__ + "static/media/Scaling.b3713b04075a7d6b193071b5eecb820a.svg";
export { ForwardRef as ReactComponent };